import { useWebNotification } from "@vueuse/core";
import { computed } from "@vue/composition-api";
import store from "@/store";

/**
 * Nieuwe inkomende conversaties in 'Nieuw': notifyConversationUnassigned
 * Wanneer een conversatie aan mij wordt toegewezen: notifyConversationAssigned
 * Elke nieuwe reactie van conversaties in 'Nieuw': notifyIncomingMessageNew
 * Nieuwe reactie op een aan mij toegewezen conversatie: notifyIncomingMessage
 * A new teamchat has been started (group): notifyTeamchatStarted
 * A new message in a teamchat: notifyTeamchatMessage
 */
export default function useWebNotifications() {
    const notifyConversationUnassigned = computed({
        get: () => store.state.webNotifications.notifyConversationUnassigned,
        set: (val) => {
            store.commit("webNotifications/UPDATE_NOTIFY_CONVERSATION_UNASSIGNED", val);
        },
    });
    const notifyConversationAssigned = computed({
        get: () => store.state.webNotifications.notifyConversationAssigned,
        set: (val) => {
            store.commit("webNotifications/UPDATE_NOTIFY_CONVERSATION_ASSIGNED", val);
        },
    });
    const notifyIncomingMessageNew = computed({
        get: () => store.state.webNotifications.notifyIncomingMessageNew,
        set: (val) => {
            store.commit("webNotifications/UPDATE_NOTIFY_INCOMING_MESSAGE_NEW", val);
        },
    });
    const notifyIncomingMessage = computed({
        get: () => store.state.webNotifications.notifyIncomingMessage,
        set: (val) => {
            store.commit("webNotifications/UPDATE_NOTIFY_INCOMING_MESSAGE", val);
        },
    });
    const notifyTeamchatStarted = computed({
        get: () => store.state.webNotifications.notifyTeamchatStarted,
        set: (val) => {
            store.commit("webNotifications/UPDATE_NOTIFY_TEAMCHAT_STARTED", val);
        },
    });
    const notifyTeamchatMessage = computed({
        get: () => store.state.webNotifications.notifyTeamchatMessage,
        set: (val) => {
            store.commit("webNotifications/UPDATE_NOTIFY_TEAMCHAT_MESSAGE", val);
        },
    });

    const vueUseWebNotification = (options) => useWebNotification(options);

    return {
        notifyConversationUnassigned,
        notifyConversationAssigned,
        notifyIncomingMessageNew,
        notifyIncomingMessage,
        notifyTeamchatStarted,
        notifyTeamchatMessage,

        vueUseWebNotification, // VueUse web notification instance.
    };
}
